import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=2618f7e3&scoped=true"
import script from "./Pedidos.vue?vue&type=script&setup=true&lang=js"
export * from "./Pedidos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=2618f7e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618f7e3",
  null
  
)

export default component.exports